import { NavLink } from 'react-router-dom';
import PageLayout from './PageLayout';

const documents = [
  ['/mentions-legales', 'Mentions légales'],
  ['/politique-confidentialite', 'Confidentialité'],
  ['/cgv', 'Conditions générales de vente'],
  ['/politique-cookies', 'Cookies'],
];
export default function LegalLayout({ title, children }) {
  return <PageLayout title={title} eyebrow="INFORMATIONS & TRANSPARENCE" className="legal-page"><div className="legal-grid"><aside><nav className="legal-navigation" aria-label="Documents légaux"><p className="page-eyebrow">VOS INFORMATIONS UTILES</p>{documents.map(([to, label]) => <NavLink key={to} to={to}>{label}</NavLink>)}</nav><p className="legal-help">Une question ?<br /><a href="mailto:contact@auto-formations.fr">Contactez-nous par email ↗</a></p></aside><article className="legal-document">{children}</article></div></PageLayout>;
}
